/* ===================================================================
   MINICART  →  assets/cart-drawer.js
   Käyttää Shopifyn Cart AJAX API:a:
     GET  /cart.js
     POST /cart/add.js
     POST /cart/change.js
   Hinnat/valuutta tulevat Shopifyltä (item.final_line_price, cart.total_price)
   valmiiksi muotoiltuina — ei käsin laskettuja hintoja/veroja.
   =================================================================== */
(function () {
  function init() {
    var overlay = document.querySelector('[data-cart-overlay]');
    var drawer = document.querySelector('[data-cart-drawer]');
    var body = document.querySelector('[data-cart-body]');
    if (!drawer || !overlay || !body) return;

    var cartIcon = document.getElementById('cart-icon-bubble');
    var foot = drawer.querySelector('[data-cart-foot]');
    var lastFocus = null;

  /* ---------- Rahan muotoilu ----------
     Pakotettu suomalainen euromuoto: "1 234,56 €"
       - välilyönti (kapea sitomaton) tuhaterottimena
       - pilkku desimaalierottimena
       - euromerkki hinnan JÄLKEEN, sitomattomalla välilyönnillä
     Ei nojata kaupan money_formatiin (voi olla euro edessä tms.) eikä
     Shopify.formatMoneyyn (jota teema ei lataa).
     Syöte = senttejä (kokonaisluku), kuten /cart.js palauttaa. */
  var THIN = '\u202f';      // narrow no-break space (tuhaterotin)
  var NBSP = '\u00a0';      // no-break space (ennen €-merkkiä)

  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function formatMoney(cents) {
    var neg = cents < 0;
    var n = Math.abs(Number(cents) || 0);
    // Näytä desimaalit aina (26,00 €). Jos halutaan piilottaa tasaeurot,
    // vaihda seuraava rivi ehdolliseksi.
    var value = (n / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = groupThousands(parts[0], THIN);
    var body = intPart + ',' + parts[1];
    return (neg ? '-' : '') + body + NBSP + '\u20ac';
  }

  /* ---------- Avaus / sulku ---------- */
  function openDrawer() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    // pakota reflow ennen transitionia
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
    // Ilmoita noutoaikataululle (alustus + checkout-lukituksen tarkistus)
    document.dispatchEvent(new CustomEvent('cart-drawer:rendered'));
  }
  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Renderöinti ---------- */
  function itemHTML(item, line) {
    var img = item.image
      ? '<img src="' + safeUrl(item.image.replace(/(\.[^.]*)$/, '_160x$1')) + '" alt="" width="68" height="68" loading="lazy">'
      : '';
    var variant = (item.product_has_only_default_variant)
      ? ''
      : '<div class="cart-item__variant">' + escapeHtml(item.variant_title || '') + '</div>';
    var onSale = item.original_line_price > item.final_line_price;
    var priceHTML = onSale
      ? '<span class="cart-item__price-now cart-item__price-now--sale">' + formatMoney(item.final_line_price) + '</span>' +
        '<s class="cart-item__price-was">' + formatMoney(item.original_line_price) + '</s>'
      : '<span class="cart-item__price-now">' + formatMoney(item.final_line_price) + '</span>';
    // Minimimäärä + erä line-item propertyistä (_min / _step). Oletus 1.
    var props = item.properties || {};
    var pmin = parseInt(props._min, 10) || 1;
    var pstep = parseInt(props._step, 10) || 1;
    var propsHtml = '';
    for (var pk in props) {
      if (!props.hasOwnProperty(pk) || pk.charAt(0) === '_' || !props[pk]) continue;
      propsHtml += '<div class="cart-item__prop"><span>' + escapeHtml(pk) + ':</span> ' + escapeHtml(props[pk]) + '</div>';
    }
    return '' +
      '<li class="cart-item" data-cart-item data-line="' + line + '" data-key="' + item.key + '"' +
      ' data-min="' + pmin + '" data-step="' + pstep + '">' +
      '<a href="' + safeUrl(item.url) + '" class="cart-item__img">' + img + '</a>' +
      '<div class="cart-item__info">' +
      '<a href="' + safeUrl(item.url) + '" class="cart-item__name">' + escapeHtml(item.product_title) + '</a>' +
      variant +
      propsHtml +
      '<div class="cart-item__row">' +
      '<div class="qty" data-qty>' +
      '<button type="button" class="qty__btn" data-qty-down aria-label="Vähennä määrää"' + (item.quantity <= pmin ? ' disabled' : '') + '>−</button>' +
      '<span class="qty__val" data-qty-val>' + item.quantity + '</span>' +
      '<button type="button" class="qty__btn" data-qty-up aria-label="Lisää määrää">+</button>' +
      '</div>' +
      '<div class="cart-item__price">' + priceHTML + '</div>' +
      '</div>' +
      '<button type="button" class="cart-item__remove" data-cart-remove>Poista</button>' +
      '</div>' +
      '</li>';
  }

  function render(cart, newKey, silent) {
    updateBadge(cart.item_count);

    // BODY = vain lista (tai tyhjä-tila). Footer on erillinen kiinteä elementti.
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
        '<p>Ostoskorisi on tyhjä</p>' +
        '<a href="/collections/all" class="cart-drawer__continue" data-cart-close>Jatka ostoksia</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      bindClose();
      return;
    }

    var items = cart.items.map(function (it, i) { return itemHTML(it, i + 1); }).join('');
    body.innerHTML = '<ul class="cart-drawer__items" role="list">' + items + '</ul>';

    // Animoi VAIN juuri lisätty rivi (ei koko listaa joka avauksella → ei "hyppyä")
    if (newKey) {
      var newRow = body.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(newKey) : newKey) + '"]');
      if (newRow) newRow.classList.add('is-new');
    }

    // Kiinteä footer: päivitä vain arvot, älä rakenna uudelleen (napit/kuuntelijat säilyvät)
    if (foot) {
      foot.hidden = false;
      var savings = foot.querySelector('[data-cart-savings]');
      var savingsAmt = foot.querySelector('[data-cart-savings-amt]');
      if (savings && savingsAmt) {
        if (cart.total_discount > 0) {
          savingsAmt.textContent = formatMoney(cart.total_discount);
          savings.hidden = false;
        } else {
          savings.hidden = true;
        }
      }
      var sub = foot.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }

    bindItemEvents();
    bindClose();

    // Ilmoita korin muutoksesta (scheduler tarkistaa jääkö maksurivi orvoksi).
    // silent=true kun render laukesi pickup:updatedista (= reconcilen oma tulos):
    // ei dispatchata cart:changedia takaisin → katkaisee event-silmukan lähteestä.
    if (!silent){
      document.dispatchEvent(new CustomEvent('cart:changed', { detail: { cart: cart } }));
    }
  }

  function updateBadge(count) {
    if (!cartIcon) return;
    var badge = cartIcon.querySelector('.header__badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'header__badge';
        cartIcon.appendChild(badge);
      }
      badge.textContent = count < 100 ? count : '!';
    } else if (badge) {
      badge.remove();
    }
  }

  /* ---------- Cart API ---------- */
  function fetchCart(newKey) {
    drawer.classList.add('is-loading');
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart, newKey); drawer.classList.remove('is-loading'); return cart; })
      .catch(function () { drawer.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    drawer.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); drawer.classList.remove('is-loading'); return cart; })
      .catch(function () { drawer.classList.remove('is-loading'); });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  /* ---------- Tapahtumat riveille ---------- */
  function bindItemEvents() {
    body.querySelectorAll('[data-cart-item]').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var val = row.querySelector('[data-qty-val]');
      var cur = val ? parseInt(val.textContent, 10) : 1;
      var min = parseInt(row.getAttribute('data-min'), 10) || 1;
      var step = parseInt(row.getAttribute('data-step'), 10) || 1;
      var down = row.querySelector('[data-qty-down]');
      var up = row.querySelector('[data-qty-up]');
      var rem = row.querySelector('[data-cart-remove]');
      // − : vähennä stepin verran, mutta ei alle minimin (poisto tapahtuu Poista-napista)
      if (down) down.addEventListener('click', function () {
        var next = cur - step;
        if (next < min) return;            // ei alle minimin
        changeLine(line, next);
      });
      // + : lisää stepin verran
      if (up) up.addEventListener('click', function () { changeLine(line, cur + step); });
      if (rem) rem.addEventListener('click', function () { changeLine(line, 0); });
    });
  }

  function bindClose() {
    body.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Turvallinen href/src: salli vain suhteelliset polut ja http(s), estä
  // javascript:/data:/vbscript: ja escapoi HTML-attribuuttiin.
  function safeUrl(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (s === '') return '';
    var stripped = s.replace(/[\u0000-\u001F\u007F]/g, '').toLowerCase();
    if (/^(javascript|data|vbscript|file):/.test(stripped)) return '';
    return escapeHtml(s);
  }

  /* ---------- Globaalit kuuntelijat ---------- */
  // Korin ikoni avaa drawerin (delegoitu dokumenttiin → ei riipu latausjärjestyksestä,
  // osuu myös kun klikataan badge/svg ikonin sisällä). Estä siirtyminen /cart-sivulle.
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble');
    if (!icon) return;
    e.preventDefault();
    openDrawer();
    fetchCart();
  });

  // Sulku: overlay, close-nappi, Esc
  overlay.addEventListener('click', closeDrawer);
  drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Noutoaikataulu muutti koria (maksurivi lisätty/poistettu) → päivitä välisumma & badge.
  // Ei rakenna footeria uudelleen → scheduler säilyy.
  document.addEventListener('pickup:updated', function (e) {
    // Jos scheduler toimitti valmiin cart-objektin, renderöi suoraan ilman hakua.
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') {
      render(cart, undefined, true);   // silent: älä dispatchaa cart:changedia takaisin
    } else {
      fetchCart();
    }
  });

  // Kaappaa kaikki "lisää koriin" -lomakkeet (tuotesivu + kortit)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"], form[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], [name="add"]');
    // Kortin kori-ikoni: ikonipohjainen tila (spinner→check→kori), EI tekstiä
    var isIconBtn = btn && btn.hasAttribute('data-pcard-add');
    var origText = (btn && !isIconBtn) ? btn.textContent : '';

    if (btn) {
      btn.disabled = true;
      if (isIconBtn) {
        btn.classList.remove('is-added');
        btn.classList.add('is-loading');
      } else {
        btn.textContent = 'Lisätään…';
      }
    }

    addToCart(new FormData(form))
      .then(function (added) {
        if (cartIcon) {
          cartIcon.classList.remove('is-bump');
          void cartIcon.offsetWidth;
          cartIcon.classList.add('is-bump');
        }
        openDrawer();
        // added.key = juuri lisätty rivi → vain se animoituu (ei koko lista)
        return fetchCart(added && added.key);
      })
      .then(function () {
        if (!btn) return;
        btn.disabled = false;
        if (isIconBtn) {
          // spinner → check hetkeksi, sitten takaisin kori-ikoniksi
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); btn.blur(); }, 1400);
        } else {
          btn.textContent = origText;
        }
      })
      .catch(function (err) {
        if (btn) {
          btn.disabled = false;
          if (isIconBtn) { btn.classList.remove('is-loading', 'is-added'); btn.blur(); }
          else { btn.textContent = origText; }
        }
        var msg = (err && err.description) ? err.description : 'Lisääminen epäonnistui.';
        alert(msg);
      });
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();